module.exports = __webpack_public_path__ + "static/img/服务商_画板 1.0038d66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/服务商_画板 1.jpg
// module id = MlDe
// module chunks = 1